<template>
  <div
    v-if="entity && gridMobileDesign"
    :class="{'search': screen === 'search', 'create_set': screen === 'create_set'}"
    :style="gridMobileDesign"
    class="grid_item_container pointer"
    @click="showItem()"
    @mouseenter="startAnimation()"
    @mouseleave="stopAnimation()"
  >
    <!--<div v-if="$store.state.localStorage.currentUser.extra.credit && $store.state.localStorage.currentUser.extra.credit > 0 && getCreditDaysLeft" class="user_credit">
      <img v-lazy-load data-src="/special_badge.png">
      <div>
        ${{ $store.state.localStorage.currentUser.extra.credit }} Credit<br>
        {{ getCreditDaysLeft }}
      </div>
    </div>-->
    <img
      v-if="screen === 'create_set'"
      class="preview_item"
      v-lazy-load data-src="/icons/eye.png"
      @click.stop="previewItem()"
    >
    <img
      v-for="(image, index) in images"
      ref="itemImage"
      :key="index"
      v-lazy-load :data-src="image"
      :class="{ 'image': index === currentIndex, 'carusel_item': index !== currentIndex }"
      class="strech_image"
    >
    <div v-if="screen !== 'create_set' && !$device.isMobileOrTablet && interval" class="overlay" />
    <img v-if="screen !== 'create_set' && !$device.isMobileOrTablet && interval" class="more" v-lazy-load data-src="/more.svg" @click.stop="showItemMenu()">
    <img v-if="screen !== 'create_set' && !$device.isMobileOrTablet && interval" v-lazy-load :data-src="getHeartStyle" class="wantit" @click.stop="wantIt()">
    <PopupDialog v-if="screen !== 'create_set' && !$device.isMobileOrTablet" :type="'item'" :item="entity" class="item_context_menu" />
    <div v-if="screen !== 'create_set' && !$device.isMobileOrTablet && interval && entity.itemTotalGotItCount" class="counters">
      <div v-title="'Wantit by users'" class="badge">
        <img
          v-lazy-load data-src="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0, 0, 400,400'><g><path d='M91.973 21.313 C -31.695 82.528,-40.111 280.701,77.513 361.797 C 212.459 454.835,400.000 383.096,400.000 238.439 L 400.000 180.478 310.018 182.739 L 220.036 185.000 220.018 232.691 C 220.000 279.624,220.436 280.278,247.500 273.899 C 286.032 264.818,263.911 287.407,222.697 299.226 C 150.877 319.824,80.882 178.501,137.518 127.246 C 186.074 83.304,290.337 91.970,303.163 141.014 C 306.877 155.219,317.178 160.000,344.064 160.000 L 380.000 160.000 380.000 85.000 L 380.000 10.000 340.000 10.000 C 318.000 10.000,300.000 14.270,300.000 19.490 C 300.000 24.709,284.395 22.459,265.321 14.490 C 214.996 -6.537,142.471 -3.683,91.973 21.313'/></g></svg>"
        >{{ entity.itemTotalGotItCount }}
      </div>
      <!--      <div class="badge" v-title="'purchased by users'">-->
      <!--        <img v-lazy-load data-src="/cart.svg">{{ entity.gotitCount }}-->
      <!--      </div>-->
    </div>
    <div v-if="screen !== 'create_set' && !$device.isMobileOrTablet && interval && !getSourceItem.soldOut" class="add_to_cart" @click.stop="addToCart()">
      <div>
        Add To Cart
      </div>
      <!--      <div class="badge" v-title="'purchased by users'">-->
      <!--        <img v-lazy-load data-src="/cart.svg">{{ entity.gotitCount }}-->
      <!--      </div>-->
    </div>
    <ItemPropertiesDialogComponent
      v-if="!$device.isMobileOrTablet"
      :item-prop="entity"
      :show-modal-prop="showAddToCart"
      @hide="showAddToCart = false"
    />
    <div :style="mobileDesign" class="bottom">
      <div class="item_name">
        {{ entity.name.substring(0, 48) }}
      </div>
      <PriceButton
        v-if="parseInt(getSourceItem.price) !== 0"
        :item="getSourceItem"
        :show-border="true"
        :screen="screen"
        :show-buy-it="false"
        :show-final-price-border="true"
        class="price_button"
      />
    </div>
    <div class="middle" />
    <div v-if="interval && !$device.isMobileOrTablet" class="images_indicator">
      <div
        v-for="(img, index) in images"
        :key="img"
        :class="{ 'current_indicator': index === currentIndex && interval }"
      />
    </div>
  </div>
</template>

<script>
import AbstractComponent from './AbstractComponent'
import PriceButton from './PriceButton'
import PopupDialog from './PopupDialog'
import utils from '~/mixins/utils'
import ItemPropertiesDialogComponent from '~/components/ItemPropertiesDialogComponent'

export default {
  name: 'GridItemComponent',
  components: { ItemPropertiesDialogComponent, PopupDialog, PriceButton },
  extends: AbstractComponent,
  mixins: [utils],
  props: {
    screen: {
      default: ''
    }
  },
  data () {
    return {
      showAddToCart: false,
      images: [],
      currentIndexInterval: 0,
      currentIndex: 0,
      interval: null,
      gridMobileDesign: {},
      mobileDesign: {},
      timeLeft: null
    }
  },
  computed: {
    getHeartStyle () {
      if (this.entity.extra.isWantit === 'true') {
        return '/red_heart.png'
      } else {
        return '/heart.png'
      }
    },
    getCreditDaysLeft () {
      if (this.timeLeft) {
        if (this.timeLeft.includes('day')) {
          return this.timeLeft
        } else {
          return this.timeLeft + ' Left'
        }
      }
      const daysLeft = parseInt((this.$store.state.localStorage.currentUser.extra.creditValidThru - new Date().getTime()) / (1000 * 60 * 60 * 24) + '')
      let message = ''
      if (!isNaN(daysLeft)) {
        if (daysLeft === 0) {
          message = '1 day left'
        } else if (daysLeft === 1) {
          message = daysLeft + ' day left'
        } else {
          message = daysLeft + ' days left'
        }
      }
      message = '1 Day Left!'
      return message
    },
    getSourceItem () {
      return this.$store.state.api.buckets.items[this.entity.sourceId]
    }
  },
  beforeMount () {
    this.bucketName = 'items'
  },
  mounted () {
    if (this.$device.isMobileOrTablet) {
      this.getItemImageHeight()
    }
    if (this.entity.image) {
      // this.images.push(this.entity.image.replace('https://res.cloudinary.com/gotit/image/upload/q_auto:eco,f_auto/map/', 'https://d1m6665y17lo66.cloudfront.net/fit-in/400x400/'))
      const imageUrl = this.entity.image.replace('upload/q_auto:eco,f_auto/', 'upload/w_400,h_400,q_auto:eco,f_auto/')
        .replace('https://d3q2desntvz2qi.cloudfront.net/', 'https://d3q2desntvz2qi.cloudfront.net/fit-in/400x400/')
      this.images.push(imageUrl)
    }
    if (!this.$device.isMobileOrTablet) {
      if (this.entity.image2) {
        const imageUrl = this.entity.image2.replace('upload/q_auto:eco,f_auto/', 'upload/w_400,h_400,q_auto:eco,f_auto/')
          .replace('https://d3q2desntvz2qi.cloudfront.net/', 'https://d3q2desntvz2qi.cloudfront.net/fit-in/400x400/')
        this.images.push(imageUrl)
      }
      if (this.entity.image3) {
        const imageUrl = this.entity.image3.replace('upload/q_auto:eco,f_auto/', 'upload/w_400,h_400,q_auto:eco,f_auto/')
          .replace('https://d3q2desntvz2qi.cloudfront.net/', 'https://d3q2desntvz2qi.cloudfront.net/fit-in/400x400/')
        this.images.push(imageUrl)
      }
      if (this.entity.image4) {
        const imageUrl = this.entity.image4.replace('upload/q_auto:eco,f_auto/', 'upload/w_400,h_400,q_auto:eco,f_auto/')
          .replace('https://d3q2desntvz2qi.cloudfront.net/', 'https://d3q2desntvz2qi.cloudfront.net/fit-in/400x400/')
        this.images.push(imageUrl)
      }
      if (this.entity.image5) {
        const imageUrl = this.entity.image5.replace('upload/q_auto:eco,f_auto/', 'upload/w_400,h_400,q_auto:eco,f_auto/')
          .replace('https://d3q2desntvz2qi.cloudfront.net/', 'https://d3q2desntvz2qi.cloudfront.net/fit-in/400x400/')
        this.images.push(imageUrl)
      }
    }
    this.startCreditTimer()
    this.$root.$on('credit_time_left', (timeLeft) => {
      this.timeLeft = timeLeft
    })
  },
  methods: {
    startCreditTimer () {
      if (this.$store.state.localStorage.currentUser && this.$store.state.localStorage.currentUser.extra.credit) {
        if (this.$store.state.localStorage.firstVisit) {
          const date1 = new Date(this.$store.state.localStorage.firstVisit)
          const currentDate = new Date()
          const diffTime = Math.abs(date1.valueOf() - currentDate.valueOf())
          const days = diffTime / (24 * 60 * 60 * 1000)
          if (days >= 1) {
            this.timeLeft = this.getDiff(parseInt(this.$store.state.localStorage.currentUser.extra.creditValidThru))
          }
        }
      }
    },
    getDiff (date, dateToCompare) {
      const date1 = new Date(date)
      const currentDate = dateToCompare || new Date()
      const diffTime = Math.abs(date1.valueOf() - currentDate.valueOf())
      const days = diffTime / (24 * 60 * 60 * 1000)
      let hours = (days % 1) * 24 + (Math.floor(days) * 24)
      let minutes = (hours % 1) * 60
      let secs = (minutes % 1) * 60
      hours = Math.floor(hours)
      minutes = Math.floor(minutes)
      secs = Math.floor(secs)
      if (hours < 10) {
        hours = '0' + hours
      }
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (secs < 10) {
        secs = '0' + secs
      }
      return `${hours}:${minutes}:${secs}`
    },
    getItemImageHeight (retryCount = 0) {
      setTimeout(() => {
        if ((!this.$refs.itemImage || !this.$refs.itemImage[0]) && retryCount < 5) {
          this.getItemImageHeight(retryCount + 1)
        } else if (this.$refs && this.$refs.itemImage[0]) {
          this.mobileDesign.top = this.$refs.itemImage[0].clientWidth + 'px'
          this.gridMobileDesign = null
          setTimeout(() => {
            this.gridMobileDesign = {}
            this.gridMobileDesign.height = 'calc(' + (this.mobileDesign.top) + ' + 36px)'
          }, 0)
        }
      }, 200)
    },
    addToCart () {
      this.showAddToCart = true
      this.$store.dispatch('api/trackEvent', {
        eventName: 'item_dialog_add_to_cart',
        params: {
          userId: this.$store.state.localStorage.currentUser.id,
          path: this.$route.path,
          itemId: this.entity.id
        }
      }).then().catch()
      // this.$root.$emit('show_item_dialog', this.entity, { showPropetiesOnly: true })
    },
    async wantIt () {
      let wantit = 'false'
      const params = {
        id: this.entity.id,
        type: 'WANTIT'
      }
      let firebaseAction = 'item_wantit'
      if (!this.entity.extra) {
        wantit = 'true'
      } else if (this.entity.extra.isWantit === 'true') {
        wantit = 'false'
        firebaseAction = 'item_unwantit'
      } else {
        wantit = 'true'
      }
      this.entity.extra.isWantit = wantit
      params.typeParam = wantit
      await this.$store.dispatch('api/itemExecute', params)
      this.$store.dispatch('api/trackEvent', {
        eventName: firebaseAction,
        params: {
          userId: this.$store.state.localStorage.currentUser.id,
          path: this.$route.path,
          itemId: this.entity.id
        }
      }).then().catch()
    },
    showItemMenu () {
      this.$root.$emit('background_clicked')
      setTimeout(() => {
        this.$root.$emit('show_popup_dialog' + this.entity.id, this.entity)
      }, 50)
    },
    showItem () {
      if (this.screen === 'create_set') {
        this.$emit('item_selected', this.entity)
      } else {
        this.addItemDetailsToEventsLayer('select_item', this.entityId)
        const path = '/items/' + this.encrypt(this.entityId)
        switch (this.$route.name) {
          case 'search':
          case 'stores-id':
            this.$emit('navigate', path)
            break
          default:
            this.$router.push({
              path
            })
            break
        }
      }
    },
    startAnimation () {
      this.interval = setInterval(() => {
        if (this.currentIndex + 1 < this.images.length) {
          this.currentIndex++
        } else {
          this.currentIndex = 0
        }
      }, 1000)
    },
    previewItem () {
      // this.$root.$emit('buy_it', this.item)
      this.$root.$emit('show_item_dialog', this.entity, { screen: this.screen })
    },
    stopAnimation () {
      this.currentIndex = 0
      clearInterval(this.interval)
      this.interval = null
    }
  }
}
</script>

<style scoped>
  .grid_item_container {
    position: relative;
    width: 300px;
    height: 360px;
    border-radius: 10px;
    box-shadow: 0px 0px 3px rgba(127, 130, 139, 0.29);
    border-collapse: separate;
    overflow: hidden;
  }

  .mobile_design .grid_item_container {
    width: 100%;
    height: calc(186px);
    border-radius: unset;
  }

  .mobile_design .search.grid_item_container {
    height: calc(222px);
  }

  .create_set.grid_item_container {
    /*height: calc(250px);*/
  }

  .image {
    opacity: 1;
    transition: .5s ease;
    backface-visibility: hidden;
    position: absolute;
  }

  .carusel_item {
    position: absolute;
    left: 0;
    -webkit-transition: opacity 1s ease-in-out;
    -moz-transition: opacity 1s ease-in-out;
    -o-transition: opacity 1s ease-in-out;
    transition: opacity 1s ease-in-out;
  }

  .middle {
    transition: .5s ease;
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    text-align: center;
  }

  .carusel_item {
    opacity: 0;
  }

  .mobile_design .carusel_item {
    height: 180px;
  }
  /* .grid_item_container:hover .image {
    opacity: 0;
  } */

  .grid_item_container:hover .middle {
    opacity: 1;
  }

  .text {
    background-color: #f61948;
    color: white;
    font-size: 16px;
    padding: 16px 32px;
  }

  .carusel {
    position: relative;
  }

  img {
    position: relative;
    top: 0;
    left: 0;
  }

  .images_indicator {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    position: relative;
    bottom: 140px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .images_indicator div {
    height: 10px;
    width: 10px;
    background-color: white;
    border: 2px solid red;
    border-radius: 50%;
    align-self: flex-end;
    margin: 0.3em;
  }

  .current_indicator {
    background-color: black !important;
  }

  .bottom {
    background-color: white;
    position: relative;
    display: flex;
    align-items: center;
    padding-left: 1em;
    padding-right: 1em;
    top: 300px;
    height: 60px;
  }

  .mobile_design .bottom .item_name {
    white-space: nowrap;
    overflow: hidden;
    font-size: 12px;
    text-overflow: ellipsis;
    width: 100%;
    padding-left: 0.2em;
  }

  .mobile_design .bottom {
    height: calc(36px);
    top: 170px;
    /*padding-top: 0.3em;*/
    /*border-top: 1px solid rgba(76, 80, 90, 0.27);*/
    /*padding-bottom: 0.3em;*/
    flex-direction: column;
    align-items: flex-start;
    padding-left: 0;
    padding-right: 0;
  }

  .mobile_design .search .bottom {
    /*top: 170px !important;*/
    bottom: 0 !important;
  }

  .mobile_design .bottom .price_button {
    border: unset;
    padding: 0 0.2em;
  }

  .item_name {
    flex-grow: 1;
    margin-right: 1em;
  }

  .price_button {
    background-color: white;
    white-space: nowrap;
    font-size: 12px;
    border-radius: 15px;
    padding: 1px 6px;
    flex-grow: unset;
    border: unset !important;
  }

  .overlay {
    height: 300px;
    width: 300px;
    position: absolute;
    background-color: rgba(77, 78, 84, 0.33);
  }

  .more {
    width: 30px;
    position: absolute;
    right: 0;
    background-color: white;
    border-radius: 50%;
    padding: 0.4em;
    top: 10px;
    left: 260px;
    z-index: 4000;
    box-shadow: 0 0 3px rgba(127, 130, 139, 0.53);
  }

  .wantit {
    /*right: 40px;*/
    width: 30px;
    position: absolute;
    background-color: white;
    border-radius: 50%;
    padding: 0.4em;
    top: 10px;
    left: 225px;
    z-index: 1501;
    box-shadow: 0 0 3px rgba(127, 130, 139, 0.53);
  }

  .add_to_cart {
    width: 100px;
    position: absolute;
    color: #f61948;
    /*right: 0;*/
    height: 30px;
    font-size: 13px;
    background-color: white;
    border-radius: 15px;
    padding: 0.1em;
    padding-top: 0.2em;
    top: 245px;
    right: 5px;
    z-index: 15000;
    box-shadow: 0px 0px 3px rgba(127, 130, 139, 0.53);
  }

  .add_to_cart:hover {
    background-color: #f61948;
    color: white;
  }

  .badge {
    align-self: center;
    display: flex;
    background-color: white;
    border-radius: 15px;
    padding-left: 0.5em;
    padding-right: 0.5em;
    height: 30px;
    align-items: center;
  }

  .badge img {
    width: 15px;
    height: 15px !important;
    filter: invert(56%) sepia(76%) saturate(6578%) hue-rotate(334deg) brightness(105%) contrast(86%);
    margin-right: 0.5em;
  }

  .counters {
    display: flex;
    top: 256px;
    left: 5px;
    position: absolute;
  }

  .item_context_menu {
    position: absolute;
    top: 200px;
    width: 280px;
    margin-right: -2.4em;
    z-index: 130;
  }

  .strech_image {
    width: 100%;
  }

  .user_credit img {
    width: 120px;
  }

  .user_credit {
    position: absolute;
    z-index: 2;
    margin-top: 2em;
  }

  .user_credit div {
    position: absolute;
    display: inline-block !important;
    margin-top: 0.3em !important;
    margin-left: 0.8em !important;
    line-height: 13px;
    font-size: 13px;
    color: white;
    /*font-family: 'HKGroteskBold', serif;*/
    font-weight: bold;
    z-index: 3;
    left: 20px;
  }

  .preview_item {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 0;
    left: 260px;
    z-index: 1;
  }
  .mobile_design .preview_item {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    left: 77px;
  }
</style>
